import React, { useState } from "react";
import { Button, Input } from "antd";
import { LockOutlined } from "@ant-design/icons";
import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import useUser from "../../hooks/useUser";
import Sheet from "./Sheet";

// Change password while logged in. Members added by an admin start with
// their mobile number as the password, so this is where they replace it.
const ChangePasswordSheet = ({ open, onClose }) => {
  const { changePassword } = useUser();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");

  const close = () => {
    setCurrent("");
    setNext("");
    setConfirm("");
    onClose();
  };

  const { mutate, isPending } = useMutation({
    mutationFn: changePassword,
    onSuccess: () => {
      toast.success("Password changed");
      close();
    },
    onError: (err) => toast.error(err?.response?.data?.message || "Could not change the password"),
  });

  const submit = (e) => {
    e.preventDefault();
    if (!current) return toast.error("Enter your current password");
    if (next.length < 6) return toast.error("New password must be at least 6 characters");
    if (next !== confirm) return toast.error("New passwords don't match");
    if (next === current) return toast.error("Choose a password different from the current one");
    mutate({ oldPass: current, password: next });
  };

  return (
    <Sheet open={open} onClose={close}>
      <form className="sheet-form" onSubmit={submit}>
        <h2 className="sheet-form__title">Change password</h2>
        <p className="sheet-form__hint">
          If an admin added you, your current password is your mobile number.
        </p>
        <Input.Password
          size="large"
          prefix={<LockOutlined />}
          placeholder="Current password"
          autoComplete="current-password"
          value={current}
          onChange={(e) => setCurrent(e.target.value)}
        />
        <Input.Password
          size="large"
          prefix={<LockOutlined />}
          placeholder="New password (6+ characters)"
          autoComplete="new-password"
          value={next}
          onChange={(e) => setNext(e.target.value)}
        />
        <Input.Password
          size="large"
          prefix={<LockOutlined />}
          placeholder="Confirm new password"
          autoComplete="new-password"
          value={confirm}
          onChange={(e) => setConfirm(e.target.value)}
        />
        <Button type="primary" htmlType="submit" size="large" block loading={isPending}>
          Change password
        </Button>
      </form>
    </Sheet>
  );
};

export default ChangePasswordSheet;
